// extracted by mini-css-extract-plugin
export default {"label":"UserForm_label__-0rPc","inputBox":"UserForm_inputBox__v2ega","button":"UserForm_button__pp7hE"};